import { photoUrl, thumbnailUrl, videoUrl } from "./urls";

const nightOfRelease = {
    id: 212,
    date: 'December 2021',
    image: `${thumbnailUrl}/nightOfRelease.png`,
    title: 'The Night of Release',
    url: `${videoUrl}/the-night-of-release.mp4`
};
const iInnovatorz = {
    id: 210,
    date: 'October 2021',
    image: `${thumbnailUrl}/iInnovationz.png`,
    title: 'iInnovatorz',
    url: `${videoUrl}/iInnovatorz.mp4`
};
const iCookz = {
    id: 209,
    date: 'September 2021',
    image: `${thumbnailUrl}/iCookz.png`,
    title: 'iCookz',
    url: `${videoUrl}/iCookz.mp4`
};
const iWrestler = {
    id: 208,
    date: 'August 2021',
    image: `${thumbnailUrl}/iWrestler.png`,
    title: 'iWrestler',
    url: `${videoUrl}/iWrestler.mp4`
};
const design = {
    id: 206,
    date: 'June 2021',
    image: `${thumbnailUrl}/design.png`,
    title: 'UI/UX Design',
    url: `${videoUrl}/iUix-design.mp4`
};
const firstIseatzAfternoonz = {
    id: 207,
    date: 'July 2021',
    image: `${thumbnailUrl}/iAfternoonz.png`,
    title: 'iSeatz Afternoonz',
    url: `${videoUrl}/iSeatz-afternoonz.mp4`
};
const holidaySpirit = {
    id: 221,
    date: 'December 2021',
    image: `${thumbnailUrl}/holidaySpirit.png`,
    title: 'iZ Holiday Spirit',
    url: `${videoUrl}/iZ-Holiday-Spirit.mp4`
};
const bestSong = {
    id: 203,
    date: 'March 2021',
    image: `${thumbnailUrl}/bestSong.png`,
    title: 'iSeatz Will Get You There',
    url: `${videoUrl}/iseatz-will-get-you-there.mp4`
};
const wrongYear = {
    id: 301,
    date: 'January 2022',
    image: `${thumbnailUrl}/wrongYear.png`,
    title: 'Wrong Year',
    url: `${videoUrl}/wrong-year.mp4`
};
const historyLesson = {
    id: 302,
    date: 'February 2022',
    image: `${thumbnailUrl}/history.png`,
    title: 'History Lesson',
    url: `${videoUrl}/History.mp4`
};
const thor = {
    id: 303,
    date: 'March 2022',
    image: `${thumbnailUrl}/thor.png`,
    title: 'Training to be Thor',
    url: `${videoUrl}/hammers.mp4`
};
const workMode = {
    id: 304,
    date: 'April 2022',
    image: `${thumbnailUrl}/workMode.png`,
    title: 'Getting Into Work Mode',
    url: `${videoUrl}/work-mode.mp4`
};
const iSickz = {
    id: 305,
    date: 'May 2022',
    image: `${thumbnailUrl}/iSickz.png`,
    title: 'iSickz',
    url: `${videoUrl}/iSickz.mp4`
};
const wfh = {
    id: 120,
    date: 'May 2020',
    image: `${thumbnailUrl}/iConnectz.png`,
    title: 'Work From Home Day',
    url: `${videoUrl}/iConnectz.mp4`
};
const unaired = {
    id: 211,
    date: 'November 2021',
    image: `${thumbnailUrl}/unaired.png`,
    title: 'Unaired',
    url: `${videoUrl}/unaired.mp4`
};
const lego = {
    id: 201,
    date: 'January 2021',
    image: `${photoUrl}/lego-office.png`,
    title: 'Lego Office',
    url: `${videoUrl}/lego.mp4`
};
const spiderman = {
    id: 224,
    date: 'October 2021',
    image: `${thumbnailUrl}/spiderman.png`,
    title: 'The Spiderman',
    url: `${videoUrl}/spiderman.mp4`,
};
const iFitz = {
    id: 306,
    date: 'June 2022',
    image: `${thumbnailUrl}/iFitz.png`,
    title: 'iFitz',
    url: `${videoUrl}/iFitz.mp4`,
};
const exitInterview = {
    id: 321,
    date: 'July 2022',
    image: `${thumbnailUrl}/exit.png`,
    title: 'Exit Interview',
    url: `${videoUrl}/i-love-you-iSeatz.mp4`
}

export const videos = [nightOfRelease, iInnovatorz, iCookz, iWrestler, design, firstIseatzAfternoonz,
    holidaySpirit, bestSong, wrongYear, historyLesson, thor, workMode, iSickz, wfh, unaired,
    lego, spiderman, iFitz, exitInterview];
